

































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import OtLocaleFlag from './OtLocaleFlag.vue';

@Component({
    components: {
        OtLocaleFlag,
    },
    name: 'OtLocaleSwitch',
})
export default class OtLocaleSwitch extends Vue {

    @Prop({ default: 'common.localization.switch.title', type: String })
        title!: string;

    @Prop({ default: 'common.localization.switch.subtitle', type: String })
        subtitle!: string;

    loading = false;

    opened = false;

    mounted(): void {
        this.$emit('opened', this.opened);
    }

    async onLocaleChange(locale: string) {
        this.loading = true;

        try {
            await this.$localization.setLocale(locale);

            this.$emit('change', this.$localization.locale);
        } finally {
            this.loading = false;
            this.close();
        }
    }

    start(el: HTMLElement): void {
        el.style.height = `${el.scrollHeight}px`;
    }

    end(el: HTMLElement): void {
        el.style.height = '';
    }

    public toggle(): void {
        this.opened = !this.opened;

        this.$emit('opened', this.opened);
    }

    public open(): void {
        this.opened = true;

        this.$emit('opened', this.opened);
    }

    public close(): void {
        this.opened = false;

        this.$emit('opened', this.opened);
    }

}
